import { render } from "./gang-mark-crash.vue?vue&type=template&id=39071ecd"
import script from "./gang-mark-crash.vue?vue&type=script&lang=js"
export * from "./gang-mark-crash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__